var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2450ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4014bd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-157 -6095)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(157 6095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1366.963-112.022a2.993,2.993,0,0,1,2.963-3.023,2.993,2.993,0,0,1,2.963,3.023A2.993,2.993,0,0,1-1364-109,2.993,2.993,0,0,1-1366.963-112.022Zm.741-8.311v-1.018a6.84,6.84,0,0,1,3.878-6.179c2.264-1.063,3.9-3.885,3.9-5.27a5.618,5.618,0,0,0-5.555-5.666,5.618,5.618,0,0,0-5.555,5.666,2.245,2.245,0,0,1-2.223,2.267A2.245,2.245,0,0,1-1374-132.8a10.114,10.114,0,0,1,10-10.2,10.114,10.114,0,0,1,10,10.2c0,3.063-2.6,7.564-6.482,9.389a2.279,2.279,0,0,0-1.3,2.06v1.018a2.244,2.244,0,0,1-2.222,2.266A2.244,2.244,0,0,1-1366.222-120.333Z",
    transform: "translate(1561 6261)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.8bd288e543f51dadb719c16ae5444461.svg";
export { ForwardRef as ReactComponent };